import React from "react";

import FwPaymentHistoryScreen from "../../pages/FwPaymentHistoryScreen";

const PaymentHistoryPage = ({
  activeTab,
  onTabChange,
  onNavChange,
}) => {
  return (
    <FwPaymentHistoryScreen
      activeTab={activeTab}
      onTabChange={onTabChange}
      onNavChange={onNavChange}
    />
  );
};

export default PaymentHistoryPage;